<template>
  <div v-if="numFiles != 0">
    <h3 v-html="title" />
    <div
      v-for="(file, key) in modelValue"
      :key="'file-' + key"
      :data-test="'file-attach-file-' + key"
      class="row align-middle push-down conversion-item"
    >
      <div :data-test="'file-attach-remove-file-' + key" class="small-12 columns">
        <a class="button small secondary no-margin" name="remove" @click="removeFile(key)">
          {{ removeFileLabel }}
        </a>
        <span class="file-name">{{ file.name }} - {{ sizeOf(file.size) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFileFieldAttachedFiles',
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      default: 'Valgte filer:'
    },
    removeFileLabel: {
      type: String,
      default: 'Slet fil'
    },
    noFilesLabel: {
      type: String,
      default: 'Ingen fil valgt'
    }
  },
  computed: {
    numFiles() {
      if (this.modelValue === undefined || this.modelValue === null) {
        return 0;
      }

      return this.modelValue.length;
    }
  },
  methods: {
    removeFile(key) {
      var val = this.modelValue.toSpliced(key, 1);
      this.$emit('update:modelValue', val);
    },
    sizeOf(bytes) {
      if (bytes == 0) {
        return '0.00 B';
      }
      var e = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + ' KMGTP'.charAt(e) + 'B';
    }
  }
};
</script>
<style scoped>
.file-name {
  margin-left: 20px;
}
</style>
